<template>
  <div>
    <b-modal
    ref="inventory-history-modal"
    title="Lịch sử tồn kho"
    size="xl"
    :visible="isVisible"
    @hidden="onHidden"
    :no-close-on-backdrop="false"
    :no-close-on-esc="false"
    :hide-header-close="false"
    >
    <template v-slot:modal-header="{ close }">
      <div class="d-flex w-100">
        <h5 class="modal-title">Lịch sử tồn kho</h5>
        <button type="button" class="close" @click="close" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </template>
    <div class="inventory-history-modal">
       <!-- Filter Section --> <b-row class="mb-4"
        > <b-col md="3"
          > <b-form
            > <b-form-group
              id="input-group-store"
              label-for="input-store"
              > <Autosuggest
                :model="selectedHistory"
                :suggestions="filteredOptions"
                :placeholder="'Chọn kho'"
                :limit="10"
                @select="onSelectedHistory"
                @change="onInputChangeHistory"
                suggestionName="suggestionName"
              /> </b-form-group
            > </b-form
          > </b-col
        > <b-col md="2"
          > <date-picker
            placeholder="Từ ngày"
            class="form-control-sm"
            :config="dpConfigs.date"
            v-model="dpForm.startDate"
          ></date-picker
          > </b-col
        > <b-col md="2"
          > <date-picker
            placeholder="Đến ngày"
            class="form-control-sm"
            :config="dpConfigs.date"
            v-model="dpForm.endDate"
          ></date-picker
          > </b-col
        > <b-col
          > <b-button
            style="fontweight: 600; width: 70px"
            variant="primary"
            size="sm"
            @click="onFilter"
            >Lọc</b-button
          > <b-button
            variant="outline-primary"
            size="sm"
            class="ml-2"
            :disabled="onExportingHistory"
            @click="exportHistoryExcel"
            > <i class="far fa-file-excel"></i> {{
              onExportingHistory ? 'Đang xuất...' : 'Xuất Excel'
            }} </b-button
          > </b-col
        > </b-row
      > <!-- History Table --> <b-table
        :items="historyItems"
        :fields="historyFields"
        bordered
        hover
        :busy="onLoadingHistory"
        class="mb-3"
        > <template v-slot:table-busy
          > <vcl-table
            :speed="5"
            :animate="true"
            :columns="6"
          ></vcl-table
          > </template
        > <template v-slot:cell(code)="row"
          >
          <div
            :class="{ productCode: isHistoryDocumentClickable(row.item) }"
            :style="isHistoryDocumentClickable(row.item) ? { cursor: 'pointer' } : null"
            @click="openHistoryDocumentLink(row.item)"
          >
             <span v-text="getHistoryDocumentLabel(row.item)"></span>
          </div>
           </template
        > </b-table
      > <!-- Pagination --> <b-row
        > <b-col
          >
          <p
            class="mt-3 text-dark"
            style="font-weight: 500"
          >
             Tổng: {{ convertPrice(totalItems) }}
          </p>
           </b-col
        > <b-col
          > <BPaginationNavCustom
            :number-of-pages="totalPages || 1"
            v-show="totalPages > 1"
            :current-page="page"
            :total-page="totalPages"
            :linkParams="{}"
            @page-change="handlePageChange"
          /> </b-col
        > </b-row
      >
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="closeModal">Đóng</b-button>
    </template>
    </b-modal>
    <AutoStockSlipViewModal
      :visible.sync="showAutoStockSlipViewModal"
      :slip-id="autoStockSlipViewSlipId"
      :slip-type="autoStockSlipViewSlipType"
      :direction="autoStockSlipViewDirection"
    />
  </div>
</template>

<script>
  import ApiService from '@/core/services/api.service'
  import { VclTable } from 'vue-content-loading'
  import moment from 'moment'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue'
  import {
    resolveStockHistoryDocument,
  } from '@/utils/imeiHistoryDocument'
  import autoStockSlipViewModalMixin from '@/view/mixins/auto-stock-slip-view-modal.mixin'
  import {
    buildHistoryDateParams,
    exportProductStockHistory,
  } from '@/core/services/product-stock.service'

  const WARRANTY_HISTORY = 2
  import { DP_CONFIG } from '@/utils/date'

  export default {
    name: 'InventoryHistoryModal',
    mixins: [autoStockSlipViewModalMixin],
    props: {
      productId: {
        type: [Number, String],
        required: true,
      },
      isVisible: {
        type: Boolean,
        default: false,
      },
      selectedStoreId: {
        type: [Number, String],
        default: null,
      },
      selectedStoreName: {
        type: String,
        default: '',
      },
      productCode: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        historyFields: [
          {
            key: 'count',
            label: 'STT',
          },
          {
            key: 'store',
            label: 'Kho',
          },
          {
            key: 'headNum',
            label: 'SL đầu',
            tdClass: 'text-right',
          },
          {
            key: 'afterNum',
            label: 'SL sau',
            tdClass: 'text-right',
          },
          {
            key: 'headWarrantyNum',
            label: 'SL BH đầu',
            tdClass: 'text-right',
          },
          {
            key: 'changeQuantity',
            label: 'SL thay đổi',
            tdClass: 'text-right',
          },
          {
            key: 'afterWarrantyNum',
            label: 'SL BH sau',
            tdClass: 'text-right',
          },
          {
            key: 'code',
            label: 'Mã phiếu',
            tdClass: 'text-left',
          },
          {
            key: 'action',
            label: 'Hành động',
          },
          {
            key: 'createdBy',
            label: 'Người tạo',
          },
          {
            key: 'createdAt',
            label: 'Ngày tạo',
          },
        ],
        historyItems: [],
        filteredOptions: [],
        options: [
          {
            data: [],
          },
        ],
        searchStockHistory: '',
        selectedHistory: '',
        onLoadingHistory: false,
        onExportingHistory: false,
        selectedStoreHistory: null,
        dpForm: {
          startDate: moment().subtract(15, 'days').format('DD/MM/YYYY'),
          endDate: '',
        },
        dpConfigs: DP_CONFIG,
        totalPages: 2,
        page: 1,
        totalItems: 0,
      }
    },
    components: {
      VclTable,
      Autosuggest,
      BPaginationNavCustom,
    },
    watch: {
      isVisible(newVal) {
        if (newVal) {
          // extend selected storeId and storeName to selectedHistory
          this.selectedStoreHistory = this.selectedStoreId
          this.searchStockHistory = this.selectedStoreName
          this.selectedHistory = this.selectedStoreName
          this.fetchStore()
          this.getProductStockHistory()
        }
      },
    },
    methods: {
      onSelectedHistory(option) {
        this.searchStockHistory = option.item.name
        this.selectedStoreHistory = option.item.id
        this.selectedHistory = option.item.name
      },
      onInputChangeHistory(text) {
        if (!text) {
          text = ''
        }
        this.searchStockHistory = text
        this.selectedHistory = text

        const filteredData = this.options[0].data
          .filter((item) => {
            return (
              item.name.toLowerCase().indexOf(text.toLowerCase()) > -1 ||
              item.shortName.toLowerCase().indexOf(text.toLowerCase()) > -1
            )
          })
          .slice(0, this.limit)

        this.filteredOptions = [...filteredData]
      },
      convertPrice: function (number) {
        return new Intl.NumberFormat('vn-VN').format(number)
      },
      getProductStockHistory: function () {
        if (!this.searchStockHistory || this.searchStockHistory.trim() === '') {
          this.selectedStoreHistory = null
        }

        this.page = this.$route.query.page
        if (!this.page) {
          this.page = 1
        }
        const param = {
          productId: this.productId,
          storeId: this.selectedStoreHistory,
          fromDate: this.dpForm.startDate
            ? moment(this.dpForm.startDate, 'DD/MM/YYYY').format('yyyy-MM-DD 00:00:00')
            : '',
          toDate: this.dpForm.endDate
            ? moment(this.dpForm.endDate, 'DD/MM/YYYY').format('yyyy-MM-DD 23:59:59')
            : '',
          page: this.page,
          limit: 30,
        }

        const paramQuery = {
          params: param,
        }
        this.onLoadingHistory = true

        ApiService.query(`v1/product-stocks/${this.productId}/history`, paramQuery)
          .then(({ data }) => {
            if (data.status === 200) {
              this.totalItems = data.data.totalRow
              this.totalPages = data.data.totalPage
              this.historyItems = data.data.data.map((element, index) => {
                const isWarrantyHistory = element.historyType === WARRANTY_HISTORY
                return {
                  count: index + 1,
                  store: element.storeName,
                  headNum: isWarrantyHistory ? '' : element.beforeQuantity,
                  afterNum: isWarrantyHistory ? '' : element.afterQuantity,
                  changeQuantity: element.changeQuantity,
                  headWarrantyNum: isWarrantyHistory ? element.beforeQuantity : '',
                  afterWarrantyNum: isWarrantyHistory ? element.afterQuantity : '',
                  historyType: element.historyType,
                  code: element.stockSlipCode,
                  stockSlipCode: element.stockSlipCode,
                  stockSlipId: element.stockSlipId,
                  stockSlipType: element.stockSlipType,
                  type: element.stockSlipType,
                  billId: element.billId,
                  redirectType: element.redirectType,
                  note: element.note,
                  createdBy: element.createdBy,
                  createdAt: moment(String(element.createdAt)).format('DD/MM/YYYY HH:mm:ss'),
                  action: element.action,
                }
              })
            } else {
              this.makeToastFaile('Tải dữ liệu thất bại!')
            }
            this.onLoadingHistory = false
          })
          .catch(({ response }) => {
            this.onLoadingHistory = false
            this.makeToastFaile(response.$error)
          })
      },
      fetchStore: async function () {
        this.options[0].data = []
        ApiService.get('/stores/getStores').then((response) => {
          const stores = response.data.data
          stores.map((element) => {
            let store = {
              id: element.id,
              name: element.name,
              shortName: element.shortName,
              suggestionName: element.shortName + ' ( ' + element.name + ')',
            }
            this.options[0].data.push(store)
          })
          this.filteredOptions = [...this.options[0].data]
        })
      },
      getHistoryDocumentLabel(item) {
        return resolveStockHistoryDocument(item).label
      },
      isHistoryDocumentClickable(item) {
        return resolveStockHistoryDocument(item).clickable
      },
      openHistoryDocumentLink(item) {
        this.openStockHistoryDocumentLink(item)
      },
      onFilter() {
        this.$route.query.page = 1
        this.getProductStockHistory()
      },
      async exportHistoryExcel() {
        if (this.onExportingHistory) {
          return
        }
        if (!this.searchStockHistory || this.searchStockHistory.trim() === '') {
          this.selectedStoreHistory = null
        }
        this.onExportingHistory = true
        const { fromDate, toDate } = buildHistoryDateParams(this.dpForm)
        await exportProductStockHistory(this.productId, {
          storeId: this.selectedStoreHistory,
          fromDate,
          toDate,
          productCode: this.productCode,
        })
        this.onExportingHistory = false
      },
      onHidden() {
        this.$emit('close')
      },
      showModal() {
        this.$refs['inventory-history-modal'].show()
      },
      closeModal() {
        this.$refs['inventory-history-modal'].hide()
      },
      handlePageChange(pageNum) {
        this.page = pageNum
        this.getProductStockHistory()
      },
      makeToastFaile(message) {
        this.$bvToast.toast(message, {
          title: 'Lỗi',
          variant: 'danger',
          solid: true,
          autoHideDelay: 3000,
        })
      },
    },
  }
</script>

<style lang="scss">
  .inventory-history-modal {
  .productCode:hover {
    text-decoration: underline;
    cursor: pointer;
    color: #3699ff;
  }
}
</style>

